import React from 'react'
import {Helmet} from "react-helmet";
import err from '../../assets/images/error.svg'

export default function NotFound() {
  return ( 
    <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Not Found</title>
    </Helmet>
    <div className="text-center py-5">
      <img src={err} className= ' w-100 ' alt="404"  />
    </div>
    </>
  )
}
